import React, { useEffect, useState } from "react";
import styled from "styled-components/native";
import EmptyImagePreview from "../GalleryView/utils/EmptyImage/EmptyImagePreview";
import { getShapeValue } from "../GalleryView/utils/EmptyImage/utils";
import { Image } from "expo-image";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { getImageSource, ImageSizePreset } from "@utils/image/imageOptimizer";

const RenderIcon = ({ image_url, icon, isPair }: any) => {
  const [imageUriError, setImageUriError] = useState(false);
  const { disableImageZoom } = useUserInfo();
  // Reset imageUriError when image_url changes
  useEffect(() => {
    setImageUriError(false);
  }, [image_url]);

  const isAvailableImage =
    image_url &&
    typeof image_url === "string" &&
    (image_url.startsWith("http") || image_url.startsWith("https"));

  return (
    <>
      {isAvailableImage && !imageUriError ? (
        <ProductImage
          source={getImageSource(image_url, ImageSizePreset.LIST_THUMB)}
          onError={() => {
            setImageUriError(true);
          }}
          contentFit={disableImageZoom() ? "contain" : "cover"}
        />
      ) : (
        <IconContainer>
          <EmptyImagePreview
            shape={getShapeValue({ shape: icon })}
            size={45}
            isPair={isPair}
          />
        </IconContainer>
      )}
    </>
  );
};

const ProductImage = styled(Image)`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme["core-01"]};
  border-color: ${({ theme }) => theme["core-03"]};
  border-width: 1px;
`;

const IconContainer = styled.View`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme["core-01"]};
  justify-content: center;
  align-items: center;
  border-color: ${({ theme }) => theme["core-03"]};
  border-width: 1px;
`;

export default RenderIcon;
